export class AccordionEvent {
  _isShowContent = false;

  get isShow() {
    return this._isShowContent;
  }

  show() {
    this._isShowContent = true;
  }

  hide() {
    this._isShowContent = false;
  }
}
